import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Course.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Video = makeShortcode("Video");
const FlashCard = makeShortcode("FlashCard");
const Prompt = makeShortcode("Prompt");
const Answer = makeShortcode("Answer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Dictionaries`}</h1>
    <Video alt="Dictionaries" videoId="RRwU6MI2_WA" mdxType="Video" />
    <h2>{`Check Your Understanding`}</h2>
    <FlashCard mdxType="FlashCard">
      <Prompt mdxType="Prompt">
        <p>{`Let's go back to our musicify app! How should we represent each of these sets of values in the app
code? As a `}<strong parentName="p">{`list`}</strong>{` or as a `}<strong parentName="p">{`dictionary`}</strong>{`?`}</p>
        <ul>
          <li parentName="ul">{`The songs in a single playlist?`}</li>
          <li parentName="ul">{`The number of times that each song on the app has been streamed?`}</li>
          <li parentName="ul">{`All of a user's playlists, each containing different songs?`}</li>
        </ul>
      </Prompt>
      <Answer mdxType="Answer">
        <p>{`Let's walk through each example!`}</p>
        <ul>
          <li parentName="ul">{`A single playlist of songs, can be represented one single list of values - `}<inlineCode parentName="li">{`["song1", "song2"]`}</inlineCode></li>
          <li parentName="ul">{`We want to map each number of streams to the corresponding song. Sounds like a job for a
dictionary! - `}<inlineCode parentName="li">{`{"song1": 40870543, "song2": 323}`}</inlineCode></li>
          <li parentName="ul">{`Here we can get fancy! Each playlist is a list of songs, but we want to map those lists to the
playlist names. That means we can create a dictionary where each `}<strong parentName="li">{`key`}</strong>{` (a song title) maps to a
`}<strong parentName="li">{`value`}</strong>{` that is of the type list (the list of songs in the playlist) like in the code block
below.`}</li>
        </ul>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`{"the coolest playlist title": ["song1", "song2"],
 "the most ok playlist": ["song3", "song4"]}
`}</code></pre>
      </Answer>
    </FlashCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      